<template>
    <div id="app">
        <headTop></headTop>
        <router-view/>
        <mFooter></mFooter>

    </div>
</template>

<script>
    import headTop from './common/headTop'
    import mFooter from './common/mFooter'
    // import 'babel-polyfill'

    export default {
        name: 'App',
        //pops:['navActive'],
        components: {
            headTop,
            mFooter
        },
        created(){
           this.menu()
            //this.$root.navActive = this.navActive;
        },
        methods:{
            menu() {
                window.scrollTo(0,0);
            },
        }
    }
</script>

<style lang="less">
    @import './assets/css/reset.css';
    @import './assets/font/font.css';
    @import './assets/css/common';
    html{
        height: 100%;
    }
    body{
        width: 100%;
        height: 100%;
        font-family: 'Helvetica Neue','PingFangSC-Regular', 'Helvetica';
        scrollbar-face-color:transparent;
        overflow-y:scroll;
        &::-webkit-scrollbar {
            /*width:8px;*/
            /*background-color:transparent;*/
        }
        &::-webkit-scrollbar-track {
            /*display: none;*/
            background: transparent;

        }
        &::-webkit-scrollbar-track-piece{
            background: transparent;
        }
        &::-webkit-scrollbar-thumb{
            border-radius:10px;
            -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.15);
            /*background: transparent;*/
            background-color:rgba(0,0,0,.15);
        }
        &::-webkit-scrollbar-thumb:hover {
            /*border: 1px solid #636363;*/
            background-color: #929292;
        }

        }
    #app {
        width: 100%;
        height: 100%;
        /*min-width: 1256px;*/


    }
    @media screen and(max-width: 1680px){
        #app {
            /*width: 100%;*/
            height: 100%;
            min-width: 1256px;
            /*background: pink;*/

        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue